export default __webpack_public_path__ + "static/media/wedziska.5f173e58.png";